import { Step1Content, Step2Content, Step3Content, Step4Content, Step5Content } from "./steps";
export var ADMIN_TOUR_PREFIX = "adminTour";
var steps = [
    {
        target: "[data-tour=\"" + ADMIN_TOUR_PREFIX + "-step01\"]",
        Content: Step1Content,
        placement: "auto",
        disableBeacon: true
    },
    {
        target: "[data-tour=\"" + ADMIN_TOUR_PREFIX + "-step02\"]",
        Content: Step2Content,
        placement: "auto"
    },
    {
        target: "[data-tour=\"" + ADMIN_TOUR_PREFIX + "-step03\"]",
        Content: Step3Content,
        placement: "top"
    },
    {
        target: "[data-tour=\"" + ADMIN_TOUR_PREFIX + "-step04\"]",
        Content: Step4Content,
        placement: "top"
    },
    {
        target: "[data-tour=\"" + ADMIN_TOUR_PREFIX + "-step05\"]",
        Content: Step5Content,
        placement: "bottom"
    }
];
export default steps;
